import { type ComponentProps, Suspense } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { P, match } from 'ts-pattern'

/**
 * Render an i18n-translated text
 *
 * @param props - Same with the props of import('react-i18next').Trans
 */
export default function Text(props: ComponentProps<typeof Trans>) {
  return (
    <Suspense>
      <TransAsText {...props} />
    </Suspense>
  )
}

function TransAsText(props: ComponentProps<typeof Trans>) {
  const namespaces = match(props)
    .with({ ns: P.string.minLength(1) }, () => props.ns)
    .with({ i18nKey: P.select(P.string.includes(':')) }, i18nKey =>
      i18nKey.split(':', 1),
    )
    /**
     * Parsing array of keys for fallback keys feature
     * @see https://www.i18next.com/principles/fallback#calling-with-fallback-keys
     */
    .with({ i18nKey: P.select(P.array(P.string.includes(':'))) }, i18nKey =>
      i18nKey.map(it => it.split(':', 1)).flat(),
    )
    .otherwise(() => undefined)

  const { t } = useTranslation(namespaces)

  return <Trans t={t} {...props} />
}
